// KHO MẪU — đợt 3a (docs/thiet-ke-kho-mau.md mục 7): HÀNG SỐ LIỆU trên thẻ mẫu của Super ở #/kho-mau — để Super biết mẫu nào tốt để giữ, mẫu nào cần sửa.
//   oThongKe(cho, mauId)   chỗ giữ "Đang tải số liệu…" trong thẻ (thẻ hiện NGAY, không chờ thống kê)
//   dienThongKe(cho, alive) GỌI GET /api/kho-mau/thong-ke MỘT LẦN cho cả trang → điền từng thẻ; lỗi / mất mạng → mỗi thẻ "Chưa tải được số liệu" (title nêu
//                           lời lỗi) — thẻ vẫn dùng được, hàm KHÔNG ném (không lỗi console chưa bắt). Trang đã rời (alive() = false) → không đụng DOM.
//   hangThongKe(tk)        "5 Boss · 7 kịch bản · 3 có lịch bật · 42 lượt/7 ngày · lỗi 12% · CAPTCHA 2" — mỗi mục một title giải thích; tỉ lệ lỗi ≥ 30% hoặc có
//                           CAPTCHA / đăng xuất → màu cảnh báo (data-canh-bao="1"). Không ai dùng → "Chưa có ai dùng". Chữ dựng bằng textContent (h()).
// Cách server đếm từng số + giới hạn: xem đầu tệp server/src/kho-mau-thong-ke.ts.
import { api, errMsg } from "../api";
import { h } from "../dom";

/** Giống ThongKeMau của server/src/kho-mau-thong-ke.ts (giao diện không import mã máy chủ). */
export interface ThongKeMau {
  mauId: string;
  soBossDangDung: number;
  soKichBan: number;
  soCoLichBat: number;
  luot7Ngay: number;
  luotKetThuc7Ngay: number;
  luotLoi7Ngay: number;
  tiLeLoi7Ngay: number | null;
  tamDung7Ngay: { captcha: number; dang_xuat: number; can_nguoi: number; khac: number };
}
/** Tỉ lệ lỗi từ mức này trở lên → tô cảnh báo. */
export const NGUONG_LOI = 0.3;

const so = (n: number): string => n.toLocaleString("vi-VN");
/** Phần trăm làm tròn nhưng KHÔNG nói dối ở hai đầu: có lỗi mà làm tròn ra 0 → "<1%"; chưa lỗi hết mà làm tròn ra 100 → "99%". */
function phanTram(ti: number): string {
  if (ti > 0 && ti < 0.005) return "<1%";
  return `${ti < 1 ? Math.min(99, Math.round(ti * 100)) : Math.round(ti * 100)}%`;
}

function muc(loai: string, chu: string, title: string, canhBao = false): HTMLElement {
  return h("span", { class: `km-tk-muc${canhBao ? " km-tk-canh-bao" : ""}`, "data-testid": `km-tk-${loai}`, title, dataset: canhBao ? { canhBao: "1" } : {} }, chu);
}

export function hangThongKe(tk: ThongKeMau | null): HTMLElement {
  if (!tk || tk.soKichBan <= 0) {
    return h("div", { class: "km-tk small muted", "data-testid": "kho-mau-thong-ke", title: "Chưa Boss nào có kịch bản tạo từ mẫu này (không tính bản trong Thùng rác)" }, "Chưa có ai dùng");
  }
  const ds: HTMLElement[] = [
    muc("boss", `${so(tk.soBossDangDung)} Boss`, "Số Boss đang có ít nhất một kịch bản tạo từ mẫu này (không tính bản trong Thùng rác)"),
    muc("kich-ban", `${so(tk.soKichBan)} kịch bản`, "Số kịch bản tạo từ mẫu này còn trên danh sách của các Boss"),
    muc("lich", `${so(tk.soCoLichBat)} có lịch bật`, "Số kịch bản từ mẫu này đang có lịch chạy BẬT (tự chạy theo giờ)"),
    muc("luot", `${so(tk.luot7Ngay)} lượt/7 ngày`, "Số lượt chạy (chạy thử + chạy thật, cả lượt đang chạy) bắt đầu trong 7 ngày qua"),
  ];
  if (tk.tiLeLoi7Ngay !== null) {
    const cao = tk.tiLeLoi7Ngay >= NGUONG_LOI;
    ds.push(muc("loi", `lỗi ${phanTram(tk.tiLeLoi7Ngay)}`,
      `Lượt lỗi / lượt đã kết thúc trong 7 ngày qua: ${so(tk.luotLoi7Ngay)}/${so(tk.luotKetThuc7Ngay)}. Từ ${Math.round(NGUONG_LOI * 100)}% trở lên → nên xem lại mẫu.`, cao));
  }
  const td = tk.tamDung7Ngay;
  if (td.captcha > 0) ds.push(muc("captcha", `CAPTCHA ${so(td.captcha)}`, "Số lần bot phải dừng vì CAPTCHA trong 7 ngày qua khi chạy kịch bản từ mẫu này — nhiều thì nên giảm nhịp / số lượng của mẫu", true));
  if (td.dang_xuat > 0) ds.push(muc("dang-xuat", `đăng xuất ${so(td.dang_xuat)}`, "Số lần bot phải dừng vì tài khoản bị đăng xuất trong 7 ngày qua khi chạy kịch bản từ mẫu này", true));
  if (td.can_nguoi > 0) ds.push(muc("can-nguoi", `cần người ${so(td.can_nguoi)}`, "Số lần bot dừng chờ người xử lý (câu hỏi khi vào nhóm, màn hình lạ) trong 7 ngày qua"));
  if (td.khac > 0) ds.push(muc("khac", `dừng khác ${so(td.khac)}`, "Số lần bot dừng vì lý do khác (checkpoint, xác minh, bị chặn spam…) trong 7 ngày qua"));
  const coCanhBao = ds.some((x) => x.dataset.canhBao === "1");
  const hang = h("div", { class: `km-tk small${coCanhBao ? " km-tk-co-canh-bao" : ""}`, "data-testid": "kho-mau-thong-ke", dataset: coCanhBao ? { canhBao: "1" } : {} });
  ds.forEach((x, i) => { if (i) hang.append(h("span", { class: "km-tk-cham", "aria-hidden": "true" }, " · ")); hang.append(x); });
  return hang;
}

export function oThongKe(cho: Map<string, HTMLElement>, mauId: string): HTMLElement {
  const el = h("div", { class: "km-tk-cho small muted", "data-testid": "kho-mau-thong-ke-cho" }, "Đang tải số liệu…");
  cho.set(mauId, el);
  return el;
}

export async function dienThongKe(cho: Map<string, HTMLElement>, alive: () => boolean): Promise<void> {
  if (!cho.size) return;
  let tk: Map<string, ThongKeMau>;
  try {
    const r = await api<{ mau: ThongKeMau[] }>("GET", "/api/kho-mau/thong-ke");
    tk = new Map(r.mau.map((m) => [m.mauId, m] as const));
  } catch (e) {
    // Hiện lỗi NGAY trên từng thẻ (không nuốt): thẻ vẫn bấm "Sửa hiển thị" được, chỉ thiếu số liệu. F5 / vào lại trang để thử lại.
    if (!alive()) return;
    const lyDo = `Không tải được thống kê mẫu: ${errMsg(e)}. Tải lại trang để thử lại.`;
    for (const el of cho.values()) el.replaceWith(h("div", { class: "km-tk small warn", "data-testid": "kho-mau-thong-ke-loi", title: lyDo }, "Chưa tải được số liệu"));
    return;
  }
  if (!alive()) return;
  for (const [id, el] of cho) el.replaceWith(hangThongKe(tk.get(id) ?? null));
}
